import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight } from "lucide-react";

export const EventCard = ({ ev }) => (
  <Link to={`/events/${ev.slug}`} className="card-lift bg-white rounded-2xl border border-slate-100 overflow-hidden block group" data-testid={`event-card-${ev.slug}`}>
    <div className="relative h-32">
      <img src={ev.image} alt={ev.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      <div className="absolute top-3 left-3 bg-white rounded-xl shadow-md px-2.5 py-1 text-center">
        <p className="text-[9px] font-black text-pink-600 uppercase">{ev.month}</p>
        <p className="text-base font-black leading-none text-slate-900">{ev.day}</p>
      </div>
    </div>
    <div className="p-3.5">
      <h3 className="font-bold text-sm text-slate-900 group-hover:text-pink-600 transition-colors">{ev.title}</h3>
      <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
        <MapPin className="w-3 h-3 text-pink-500" /> {ev.city}, {ev.country}
      </p>
      <div className="flex flex-wrap gap-1 mt-2.5">
        {ev.tags?.map((t) => (
          <span key={t} className="px-2 py-0.5 rounded-full bg-slate-50 border border-slate-200 text-slate-600 text-[10px] font-bold">{t}</span>
        ))}
      </div>
    </div>
  </Link>
);

export const EventsSection = ({ events = [] }) => (
  <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-5 md:p-6 h-full flex flex-col" data-testid="events-section">
    <div className="flex items-start gap-3 mb-4">
      <span className="w-9 h-9 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0"><CalendarDays style={{ width: 18, height: 18 }} /></span>
      <div>
        <h2 className="font-display text-xl sm:text-2xl font-black text-slate-900">Live &amp; Upcoming</h2>
        <p className="text-xs text-slate-500">Festivals, concerts and cultural events from around the world.</p>
      </div>
      <Link to="/events" data-testid="events-view-all" className="ml-auto text-xs font-bold text-pink-600 hover:text-pink-700 inline-flex items-center gap-1 shrink-0">
        View All Events <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1">
      {events.map((ev) => <EventCard key={ev.id} ev={ev} />)}
    </div>
  </div>
);

export default EventsSection;
